import { __t } from "@core/translation/translation";

const data = [
  {
    title: __t("Dashboard"),
    path: "/dashboard/profile",
    icon: "icon-monitor",
    iconFill: "icon-monitor-fill",
    name: "dashboard",
    id: 0,
  },
  {
    title: __t("Introducing friends"),
    path: "/dashboard/referral",
    icon: "icon-share-2",
    iconFill: "icon-share-2-fill",
    name: "referral",
    id: 1,
  },
  {
    title: __t("Settings"),
    path: "/settings/security",
    icon: "icon-settings",
    iconFill: "icon-setting-fill",
    name: "settings",
    id: 2,
  },
  {
    title: __t("Authentication"),
    path: "/authenticationLevels",
    icon: "icon-user-line",
    iconFill: "icon-user-line-fill",
    name: "authenticationLevels",
    id: 3,
  },
];
const data2 = [
  {
    title: __t("withdraw"),
    icon: "icon-cash-out-request",
    color: "red2",
    name: "withdraw",
    alertTitle: __t("Select currency to Withdraw"),
    alertSubTitle: __t("Select the type of currency you want to Withdraw"),
    id: 0,
  },
  {
    title: __t("deposit"),
    icon: "icon-plus",
    color: "primary",
    name: "deposit",
    alertTitle: __t("Select currency to deposit"),
    alertSubTitle: __t("Select the type of currency you want to deposit"),
    id: 1,
  },
];

export { data, data2 };
